import CancelModalButton from 'components/Custom/CancelModalButton'
import CustomModalFooter from 'components/Custom/CustomModalFooter'
import CustomModalHeader from 'components/Custom/CustomModalHeader'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useEffect, useState } from 'react'
import { FormGroup, Input, Modal, ModalBody } from 'reactstrap'
import AxiosInstance from 'utils/AxiosInstance'
import { useHistory } from 'react-router-dom'

function CodeModal({ enterCodeModal, setEnterCodeModal, setUnlockedCourse }) {
  const history = useHistory()

  const [accessCode, setAccessCode] = useState('')
  const [notFoundText, setNotFoundText] = useState('')

  const [loading, setLoading] = useState(false)

  const fetchCourseByAccessid = () => {
    setLoading(true)
    AxiosInstance.get(`/courses/access-code?accessCode=${accessCode}`).then(
      (data) => {
        setLoading(false)
        if (data.course_id) {
          setEnterCodeModal(false)
          history.push(`/public-catalog/${data.course_id}`)
          setUnlockedCourse(data.course_id)
        } else {
          if (data.status === 410) {
            setNotFoundText(data.message)
          } else {
            setNotFoundText(
              'No course found with this access code! Please contact academy administrator.'
            )
          }
        }
      }
    )
  }

  return (
    <Modal
      toggle={() => {
        setEnterCodeModal(false)
        // history.push(`/public-catalog`)
      }}
      isOpen={enterCodeModal}
      centered
      size='lg'
      className='scrollbar'
    >
      <CustomModalHeader
        title={'Access Code'}
        toggle={() => {
          setEnterCodeModal(false)
          // history.push(`/public-catalog`)
        }}
      />
      <ModalBody style={{ padding: '20px' }}>
        <p className='text-center'>
          Please enter the access code you received from your instructor
        </p>

        <FormGroup className='ml-0 w-75 mx-auto my-3'>
          <Input
            id='exampleFormControlInput1'
            name='first_name'
            type='text'
            style={{ height: '38px' }}
            value={accessCode}
            onChange={(e) => setAccessCode(e.target.value)}
          />
        </FormGroup>
        {notFoundText ? (
          <p className='text-center text-danger'>{notFoundText}</p>
        ) : null}
        <CustomModalFooter>
          <SubmitModalButton
            customFn={() => fetchCourseByAccessid()}
            text={!loading ? 'Join Course' : 'Joining Course ...'}
          />
          <CancelModalButton
            customFn={() => setEnterCodeModal(false)}
            text='Cancel'
          />
        </CustomModalFooter>
      </ModalBody>
    </Modal>
  )
}

export default CodeModal
